/* BIG STUDIO: en el menu movil, tocar el TITULO de un item con submenu
   despliega el submenu (antes solo funcionaba tocando la flecha).
   Reenvia el clic al <summary> para conservar el comportamiento y
   las animaciones nativas del tema. */
(function () {
  if (window.__bsDrawerFix) return;
  window.__bsDrawerFix = true;

  document.addEventListener(
    'click',
    function (ev) {
      var link = ev.target.closest('.menu-drawer summary a.menu-drawer__menu-link');
      if (!link) return;
      var summary = link.closest('summary');
      var details = link.closest('details');
      if (!summary || !details) return;
      ev.preventDefault();
      ev.stopPropagation();
      summary.click();
    },
    true
  );
})();
